<template>
    <v-group :config="groupConfig">
        <v-group :config="alignCenterConfig">
            <v-text
                    ref="text"
                    :config="textConfig"
            ></v-text>

            <v-text :config="unitsConfig"></v-text>

            <v-shape :config="indicatorConfig"></v-shape>
        </v-group>

    </v-group>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "LineSize",

        props: [
            'fromPoint',
            'toPoint',
            'color',
            'sizeFlip',
        ],

        data() {
            return {
                textWidth: 0,
            }
        },

        computed: {
            ...mapGetters('editor', [
                'getFootsInFractions',
            ]),

            ...mapGetters('line', [
                'getLineByPoints',
            ]),

            line() {
                return this.getLineByPoints(this.fromPoint, this.toPoint);
            },

            groupConfig() {
                let {x, y} = this.fromPoint;
                let rotation = this.line.angle;

                return {
                    x,
                    y,
                    rotation,
                }
            },

            alignCenterConfig() {
                // we set length of the text field the same with the line length
                // and just set text align center
                // use Math.max for 'no-wrap' the text on beginning
                let length = Math.max(this.line.length, 24);

                let x = this.line.dx >= 0 ? -length/2 : length/2;
                let rotation = this.sizeFlip ? 180 : 0;

                return {
                    x,
                    rotation,
                }
            },

            textConfig() {
                // display the line length in feet fractions
                let text = this.getFootsInFractions(this.line.lengthInFeet);
                let rotation = this.sizeFlip ? 180 : 0;
                let y = this.sizeFlip ? 24 : 10;

                return {
                    y,
                    text,
                    fontSize: 16,
                    fontFamily: 'Arial',
                    fontStyle: 'bold',
                    fill: this.color,
                    offsetX: this.textWidth / 2, // to center the text
                    // use text shadow to make contrast on the dark background, e.g. dark paint brush
                    shadowColor: 'white',
                    shadowOffset: { x: 1, y: 1 },
                    shadowOpacity: 0.3,
                    rotation,
                }
            },

            unitsConfig() {
                let rotation = this.sizeFlip ? 180 : 0;

                let x = this.textConfig.offsetX;
                x = this.sizeFlip ? -x : x;

                return {
                    x,
                    y: this.textConfig.y,
                    text: '"',
                    fontSize: 16,
                    fontFamily: 'Arial',
                    // fontStyle: 'bold',
                    fill: this.color,
                    // use text shadow to make contrast on the dark background, e.g. dark paint brush
                    shadowColor: 'white',
                    shadowOffset: { x: 1, y: 1 },
                    shadowOpacity: 0.3,
                    rotation,
                }
            },

            indicatorConfig() {
                return {
                    y: 0,
                    sceneFunc: function (context, shape) {
                        context.beginPath();
                        context.moveTo(-5, 0);
                        context.lineTo(0, 7);
                        context.lineTo(5, 0);
                        context.closePath();

                        // (!) Konva specific method, it is very important
                        context.fillStrokeShape(shape);
                    },
                    fill: this.color,
                }
            },

            textRef() {
                // get the object node to work with its properties
                return this.$refs.text?.getNode() || {};
            },

        },

        methods: {
            setTextWidth() {
                // get the correct width of the rendered text
                this.textWidth = this.textRef.getTextWidth();
            },

        },

        watch: {
            line: {
                handler(){
                    // use $nextTick to wait for rendering
                    this.$nextTick(this.setTextWidth);
                },
                deep: true,
            },
        },

        mounted() {
            this.setTextWidth();
        },

    }
</script>

<style scoped>

</style>